import * as React from "react";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { someTextSuccees, isVisible, style } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <Styled.SnackbarBoxContainer isVisible={isVisible} style={style}>
      {someTextSuccees}
    </Styled.SnackbarBoxContainer>
  );
};

// initialisation des props

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  someTextSuccees?: string;
  isVisible?: boolean;
  style?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/snack-bar/succees/component.tsx